import React, { useEffect, useRef, useState } from "react";

export default function DropdownField({
  label,
  options = [],
  value,
  onChange,
  required,
  placeholder = "Select option",
  displayValue,
  error,
  className = "",
  multiple = false, // NEW PROP
}) {
  const [open, setOpen] = useState(false);
const dropdownRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target)
    ) {
      setOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () =>
    document.removeEventListener("mousedown", handleClickOutside);
}, []);
  const selectedLabel = multiple
    ? value?.length
      ? options
          .filter((opt) => value.includes(opt.value))
          .map((opt) => opt.label)
          .join(", ")
      : placeholder
    : displayValue ||
      options.find((opt) => opt.value === value)?.label ||
      placeholder;

  const handleSelect = (selectedValue) => {
    if (multiple) {
      let updatedValues = [...(value || [])];

      if (updatedValues.includes(selectedValue)) {
        updatedValues = updatedValues.filter(
          (item) => item !== selectedValue
        );
      } else {
        updatedValues.push(selectedValue);
      }

      onChange({ target: { value: updatedValues } });
    } else {
      onChange({ target: { value: selectedValue } });
      setOpen(false);
    }
  };

  return (
   <div ref={dropdownRef} style={{ position: "relative" }}>
      {label && (
        <label className="mb-2 fs-lg fw-b">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      {/* Select Box */}
      <div
        className={`form-select ${className}`}
        style={{ cursor: "pointer", padding: "8px" }}
        onClick={() => setOpen(!open)}
      >
        {selectedLabel}
      </div>

      {/* Dropdown List */}
      {open && (
        <ul
          className="list-group position-absolute w-100 shadow-sm rounded-3 mt-1 bg-white"
          style={{ zIndex: 999, maxHeight: 200, overflowY: "auto" }}
        >
          {options.map((opt) => {
            const isSelected = multiple
              ? value?.includes(opt.value)
              : value === opt.value;

            return (
              <li
                key={opt.value}
                className="list-group-item border-0 d-flex align-items-center gap-2"
                style={{
                  cursor: "pointer",
                  background: isSelected ? "#356c89" : "#fff",
                  color: isSelected ? "#fff" : "#000",
                }}
                onClick={() => handleSelect(opt.value)}
              >
                {multiple && (
                  <input
                    type="checkbox"
                    checked={isSelected}
                    readOnly
                  />
                )}
                {opt.label}
              </li>
            );
          })}
        </ul>
      )}

      {error && (
        <span className="c-r fs-xs fw-r">
          {error}
        </span>
      )}
    </div>
  );
}